import React from 'react';

function News() {
  const articles = [
    {
      date: 'December 02, 2024',
      location: 'New York City',
      title: 'Including Animation In Your Design System',
      image: 'assets/img/news/01.jpg',
    },
    {
      date: 'December 02, 2024',
      location: 'New York City',
      title: 'Including Animation In Your Design System',
      image: 'assets/img/news/02.jpg',
    },
    {
      date: 'December 02, 2024',
      location: 'New York City',
      title: 'Including Animation In Your Design System',
      image: 'assets/img/news/02.jpg',
    },
  ];

  return (
    <section className="news-section section-padding fix">
      <div className="container">
        <div className="section-title text-center">
          <span className="sub-title style-2 wow fadeInUp">
            News & Updates
          </span>
          <h2 className="wow fadeInUp" data-wow-delay=".2s">
            Our Latest News & Articles
          </h2>
        </div>
        <div className="row">
          {articles.map((article, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`.${3 + index * 2}s`}
            >
              <div className="news-card-items">
                {index % 2 === 0 ? (
                  <div className="news-image">
                    <img src={article.image} alt={article.title} />
                  </div>
                ) : (
                  <div className="news-content">
                    <ul className="post-meta">
                      <li>
                        <i className="fa-regular fa-calendar-days"></i>
                        {article.date}
                      </li>
                      <li>
                        <i className="fa-solid fa-tag"></i>
                        {article.location}
                      </li>
                    </ul>
                    <h3>
                      <a href="news-details.html">{article.title}</a>
                    </h3>
                    <a href="news-details.html" className="link-btn">
                      Read More <i className="fa-sharp fa-regular fa-arrow-right"></i>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
          {articles.length % 2 === 1 && (
            <>
              <div
                className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay=".5s"
              >
                <div className="news-card-items">
                  <div className="news-content">
                    <ul className="post-meta">
                      <li>
                        <i className="fa-regular fa-calendar-days"></i>
                        {articles[0].date}
                      </li>
                      <li>
                        <i className="fa-solid fa-tag"></i>
                        {articles[0].location}
                      </li>
                    </ul>
                    <h3>
                      <a href="news-details.html">{articles[0].title}</a>
                    </h3>
                    <a href="news-details.html" className="link-btn">
                      Read More <i className="fa-sharp fa-regular fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay=".7s"
              >
                <div className="news-card-items">
                  <div className="news-image">
                    <img src={articles[1].image} alt={articles[1].title} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default News;